// extracted by mini-css-extract-plugin
export default {"address":"address_address__zVMD8","address_title":"address_address_title__kxi2l","name":"address_name__naMyD"};